/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { apiPersistCache } from "hooks/use-api-persist-cache";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { Logger, cyanBright } from "cms/utils/log/logger";
import { dispatch } from "data/store";
import { setLoadingForm } from "data/store/reducers/form";

/**
 * @type {(token: string, guid: string, data: Partial<SchemaForm>) => Promise<SchemaForm>}
 */
const update = SimpliCityAdminSDK.form.update;
const logTag = "[api-persist:form]";

export const apiPersistReducerMiddleware = (store) => (next) => (action) => {
    Logger.info(cyanBright(`[${logTag}] action.type: ${action.type}`));
    const result = next(action);
    
    // ignore form actions; they have their own async operations
    if (!action.type.startsWith("form")) {
        Logger.info(cyanBright(`${logTag} triggering save for ${action.type}`), { action_type: action.type });
        // console.info(cyanBright(`${logTag} triggering form save for ${action.type}`), { action_type: action.type });
        store.dispatch({ type: "form/dirty", isFormDirty: true });

        /** @type {FormReducerState} */
        const state = store.getState();
        const form = state.form;
        const steps = form?.steps;
        const questions = form?.questions;
        const guid = form?.guid;
        const name = form?.name;

        const token = apiPersistCache?.token;

        update(token, guid, { guid, name, questions, steps })
            .then((response) => {
                console.debug(`${logTag} response`, { response });
            })
            .catch((error) => {
                console.error(error);
            })
            .finally(() => {
                store.dispatch({ type: "form/dirty", isFormDirty: false });
                dispatch(setLoadingForm(false));

            });
    }

    return result;
};
